// Wait for element...
function wait_for_element(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// Get the total cart count...
function get_total_cart_count() {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var cart = JSON.parse(xhr.responseText);
      // // var total_count = cart.item_count;
      // // var complete_the_look = document.getElementsByClassName("complete-the-look")[0];
      // // if ( total_count >= 2 ) {
      // //   complete_the_look.classList.add("hide");
      // // } else {
      // //   complete_the_look.classList.remove("hide");
      // // }
      // var cart_items = cart.items;
      // var product_types = [];
      // cart_items.forEach(function (item, index) {
      //   product_types.push(item.product_type);
      // });
      // // console.log(product_types);
      // wait_for_element(".carbon-offset").then((element) => {
      //   element.insertAdjacentHTML("beforeBegin", "<div class='bundle-deals cart'></div>");
      //   if (product_types.indexOf("Trousers") > -1) {
      //     get_bundle_deal("the-24-trouser");
      //   }
      //   if (product_types.indexOf("Shirts") > -1) {
      //     get_bundle_deal("shirts");
      //   }
      //   if (product_types.indexOf("Tee") > -1) {
      //     get_bundle_deal("t-shirts");
      //   }
      // });
    }
  };
  xhr.open("GET", "/cart.js", true);
  xhr.send();
}
get_total_cart_count();

// Add bundle deals to the cart...
function get_bundle_deal(collection) {
  var minicart_deal = document.getElementById("minicart-deals").querySelector('.' + collection);
  if ( minicart_deal !== null ) {
    document.querySelector('.bundle-deals.cart').innerHTML += minicart_deal.outerHTML;
  }
}

// Collection image filter...
var collection_filter = document.querySelector(".collection__image-filter__column--items");
if ( typeof(collection_filter) != 'undefined' && collection_filter != null ) {
  collection_filter.addEventListener("click", function(event) {
    document.getElementById("collection-cards").scrollIntoView({ behavior: "smooth" });
  });
}

// Read url parameters...
function get_url_parameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
  results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// If product page...
document.addEventListener('DOMContentLoaded', () => {
  const multiVariantElement = document.querySelector('.js-variants-multi');
  if ( multiVariantElement && typeof get_url_parameter === 'function' ) {
    const variant = get_url_parameter('variant');
    if (variant) {
      check_multiple_variants(variant);
    }
  }
});

// Trigger multiple variant selection...
document.addEventListener('click', function(event) {
  var clickedLabel = event.target.closest('.product-form__input-multi label');
  if ( clickedLabel && !event.target.classList.contains('product__form__variant--disabled') ) {
    // Find the child input field inside the clicked label and get its value...
    var childInput = clickedLabel.querySelector('input');
    var selectedValue = childInput ? childInput.value : null;
    if ( selectedValue ) {
      // Remove active class from all sibling labels...
      var siblingLabels = clickedLabel.parentNode.querySelectorAll('label');
      siblingLabels.forEach(function(label) {
        label.classList.remove('active');
      });
      // Add active class to the clicked label...
      clickedLabel.classList.add('active');
      // Update the data-option attribute based on the label's context...
      if ( clickedLabel.closest('.js-productInputsSize') ) {
        document.querySelector('.js-productInputsSize').setAttribute('data-option', selectedValue);
      } 
      else if ( clickedLabel.closest('.js-productInputsLength') ) {
        document.querySelector('.js-productInputsLength').setAttribute('data-option', selectedValue);
      }
      check_multiple_variants(false);
    }
  }
});

// Check for multiple variants...
function check_multiple_variants(variant) {
  if ( variant == false ) {
    var selected_waist = document.querySelector('.js-productInputsSize')?.getAttribute('data-option');
    var selected_length = document.querySelector('.js-productInputsLength')?.getAttribute('data-option');
    if ( selected_waist && selected_length ) {
      var inventory_data = JSON.parse(document.getElementById('inventory-data').innerHTML || '{}');
      var selected_variant = '';
      var selected_variant_title = '';
      var inventory_quantity = 0;
      if ( inventory_data.variants && inventory_data.variants.length > 0 ) {
        inventory_data.variants.forEach(function(value) {
          if ( value.title === selected_waist + ' / ' + selected_length ) {
            selected_variant = value.id;
            selected_variant_title = value.title;
            inventory_quantity = value.inventory_quantity;
          }
        });
      }
      document.querySelector('input.product-variant-id').value = selected_variant;
      window.history.replaceState(null, null, '?variant=' + selected_variant);
      var addToCartButton = document.querySelector('button.product__form__add');
      var addToCartText = document.querySelector('button.product__form__add span.add-to');
      addToCartButton.setAttribute('data-variant-id', selected_variant);
      if ( inventory_quantity > 0 ) {
        if (addToCartButton.hasAttribute('disabled')) {
          addToCartButton.removeAttribute('disabled');
        }
        var pre_order = document.querySelector('input#pre-order').value;
        if ( pre_order === 'true' ) {
          addToCartText.textContent = 'Pre-order';
        } else {
          addToCartText.textContent = 'Add to Cart';
        }
        document.querySelector('span.out-of-stock').classList.add('hidden');
        document.querySelector('.hc-cta').classList.remove('hidden');
      } else {
        if (!addToCartButton.hasAttribute('disabled')) {
          addToCartButton.setAttribute('disabled', 'disabled');
        }
        addToCartText.textContent = 'Select Size';
        document.querySelector('span.out-of-stock').classList.remove('hidden');
        document.querySelector('.hc-cta').classList.add('hidden');
      }
    }
  } else {
    var inventory_data = JSON.parse(document.getElementById('inventory-data').innerHTML || '{}');
    var selected_variant = '';
    var selected_variant_title = '';
    var inventory_quantity = 0;
    if ( inventory_data.variants && inventory_data.variants.length > 0 ) {
      inventory_data.variants.forEach(function(value) {
        if ( value.id === parseInt(variant) ) {
          selected_variant = value.id;
          selected_variant_title = value.title;
          inventory_quantity = value.inventory_quantity;
        }
      });
    }
    var title = selected_variant_title.split('/').map(value => 
      value.trim().toLowerCase().replace(/[^a-zA-Z0-9]/g, '')
    );
    var size = title[0];
    var length = title[1];
    if ( size && length ) {
      setTimeout(() => {
        var size_element = document.querySelector(`label[data-id="${size}"]`);
        if ( size_element ) {
          size_element.click();
        }
      }, 1000);
      setTimeout(() => {
        var length_element = document.querySelector(`label[data-id="${length}"]`);
        if ( length_element ) {
          length_element.click();
        }
      }, 1000);
    }
  }
}

// Menu fix..
document.addEventListener('DOMContentLoaded', function() {
  const minicartHeader = document.querySelector('.minicart__header--right');
  if (minicartHeader) {
    minicartHeader.addEventListener('click', function() {
      document.body.classList.remove('overflow');
    });
  }
});

// Custom event listener for Early Bird app...
document.addEventListener('DOMContentLoaded', () => {
  const waitForElement = (selector, callback, interval = 100, timeout = 10000) => {
    const startTime = Date.now();
    const check = () => {
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
      } else if (Date.now() - startTime < timeout) {
        setTimeout(check, interval);
      }
    };
    check();
  };

  waitForElement('.earlybird__button', (earlybirdButton) => {
    const closestProductFormAdd = earlybirdButton.closest('.product__form__add');
    const allProductForms = document.querySelectorAll('.product__form__add');

    const targetProductFormAdd = Array.from(allProductForms).find(
      form => !form.contains(earlybirdButton)
    );

    if (targetProductFormAdd) {
      const attributesToCopy = [
        'data-color',
        'data-hex',
        'data-material',
        'data-style',
        'data-carbon',
        'data-original-price',
        'data-variant-id'
      ];

      attributesToCopy.forEach(attr => {
        const value = targetProductFormAdd.getAttribute(attr);
        if (value !== null) {
          earlybirdButton.setAttribute(attr, value);
        }
      });

      earlybirdButton.addEventListener('click', async (event) => {
        event.preventDefault(); // Prevent the default button action
        event.stopPropagation(); // Prevent other click events

        const form = earlybirdButton.closest('form'); // Get the nearest form to the button
        if (!form) {
          console.error('Form not found.');
          return;
        }

        // Explicitly prevent the form's default submission by preventing its 'submit' event
        form.addEventListener('submit', (submitEvent) => {
          submitEvent.preventDefault(); // Prevent the default form submission
        });

        // Create the hidden input fields using the data attributes from the earlybirdButton
        const carbonOffset = earlybirdButton.getAttribute('data-carbon');
        const material = earlybirdButton.getAttribute('data-material');

        const carbonInput = document.createElement('input');
        carbonInput.type = 'hidden';
        carbonInput.name = 'properties[carbonOffset]';
        carbonInput.value = carbonOffset ? carbonOffset : ''; // Default to empty if no value

        const materialInput = document.createElement('input');
        materialInput.type = 'hidden';
        materialInput.name = 'properties[material]';
        materialInput.value = material ? material : ''; // Default to empty if no value

        // Append the new hidden inputs to the form
        form.appendChild(carbonInput);
        form.appendChild(materialInput);

        // Create FormData from the form
        const data = new FormData(form);

        try {
          // Use the Shopify AJAX cart API to add the product
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: data
          });

          if (response.ok) {
            const result = await response.json();

            // Set a hash to auto-show the minicart
            window.location.hash = '#minicart';
            
            // Refresh the page after adding the product
            window.location.reload();

            //console.log('Product added to cart:', result);
            //alert('Product added to cart!');
          } else {
            //console.error('Failed to add product to cart:', response.statusText);
            //alert('Failed to add product to cart. Please try again.');
          }
        } catch (error) {
          //console.error('Error:', error);
          //alert('An error occurred. Please try again later.');
        }
      }, true);
    }
  });

  // Show the minicart after page reload if the hash is present
  if (window.location.hash === '#minicart') {
    const minicart = document.querySelector('.minicart');
    if (minicart) {
      minicart.classList.add('show');
      // Remove the hash from the URL after showing the minicart
      history.replaceState(null, null, window.location.pathname);
    }
  }
});

// Country selector...
document.querySelector('select#shopify-localization').addEventListener('change', function () {
  const localization_form = this.closest('form.shopify-localization-form');
  const country_code = localization_form.querySelector('input.country-code');
  country_code.value = this.value;
  localization_form.submit();
});

// Trigger country selector popup...
function open_cp() {
  const cp_popup = document.querySelector('.cp-popup');
  if ( cp_popup ) {
    cp_popup.classList.add('active');
  }
}
function close_cp() {
  const cp_popup = document.querySelector('.cp-popup');
  if ( cp_popup ) {
    cp_popup.classList.remove('active');
  }
}
const close_cp_btn = document.querySelector('.cp-popup__btn');
if ( close_cp_btn ) {
  close_cp_btn.addEventListener('click', close_cp);
}

// Product quick add feature...
document.querySelectorAll(".product-card__sizing ul.sizing li").forEach(li => {
  li.addEventListener("click", () => {
    let id = li.getAttribute("data-id");
    if (!id) return;
    let formData = {
      items: [{
        id: id,
        quantity: 1
      }]
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      window.SLIDECART_UPDATE();
      window.SLIDECART_OPEN();
    });
  });
});
